/*
 *---------------------------------------------------
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *---------------------------------------------------
 */
//standard libraries
import { useState, useEffect } from "react";
import { Canceler } from "axios";

//custom libraries
import { useOrgHandler } from "./rest";

export const useOrgResource = () => {
  const { getOrgInfoById } = useOrgHandler();

  const cancelers: any = { cancels: [] };
  const [orgInfo, setOrgInfo] = useState<any>({});

  const getOrgById = (id: any) => {
    const [res, canceler] = getOrgInfoById(id);
    cancelers.cancels = canceler;
    return res.then((r: any) => {
      setOrgInfo(r.data);
      return r.data;
    });
  };

  useEffect(() => {
    return () => {
      cancelers.cancels.forEach((cancel: Canceler) => {
        return cancel();
      });
    };
  }, []);

  return {
    orgInfo,
    setOrgInfo,
    getOrgById,
  };
};
